var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex"},[_c('div',{ref:"text",staticStyle:{"display":"none"},domProps:{"innerHTML":_vm._s(_vm.item.text)}}),_c('div',{staticClass:"courses-test-text"},[_vm._v(_vm._s(_vm.text || '...'))])])}
var staticRenderFns = []

export { render, staticRenderFns }